import { useTranslations } from "use-intl";

import { OrderLabel } from "@/features/bookings/components/OrderLabel";
import type { ReservationStatus } from "@/types/types";

const orderStatusToDescriptionMapping = {
  IN_PROGRESS: "reservations.orderInProgressDescription",
  REFUNDED: "reservations.orderRefundedDescription",
};

type Props = {
  status: ReservationStatus;
};

export const OrderStatusSection = ({ status }: Props) => {
  const t = useTranslations();

  return (
    <section className="section-card mt-2 mb-4 flex w-full flex-col gap-4">
      <div className="flex w-full items-center justify-between">
        <span className="text-sm text-text-title">
          {t("reservations.orderStatus")}
        </span>
        <OrderLabel status={status} />
      </div>
      {status === "REFUNDED" || status === "IN_PROGRESS" ? (
        <span className="text-xs text-text-tertiary">
          {t(orderStatusToDescriptionMapping[status])}
        </span>
      ) : null}
    </section>
  );
};
